<button mat-icon-button aria-label="Anexo">
    <mat-icon 
        class="hoverable" 
        aria-hidden="false"  
        (click)="download()"
    >
            attachment
    </mat-icon>
</button>